import type { ICustodian, IQuoteRequest } from 'models/secondaryMarket';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { Thunk } from 'state/state.common';
import { now } from 'utils/core/now';
import { getFrontLogger } from 'utils/loggers/FrontLogger';

import type { DealSplit } from '../realtimeQuoteForm';
import { getSecondaryMarketRtFormQuoteId } from '../realtimeQuoteForm/realTimeQuoteForm.selectors';
import { secondaryMarketQuoteCancelled, secondaryMarketQuoteRequested } from './quote.actions';

function toCustodian(row: DealSplit): ICustodian {
  return { bdrId: row.custodianId!, notional: row.notional, bdrName: null! };
}
export function secondaryMarketQuoteRequestThunk(tabId: string): Thunk<void> {
  return (dispatch, getState, { getNewGuid, selectors: { fromSecondaryMarket } }) => {
    const state = getState();
    const correlationId = getNewGuid();
    const timeZone = now().getTimezoneOffset();
    const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId);
    const isin = product?.data?.isin;
    if (isin === undefined) {
      getFrontLogger().error('If ISIN is not present, quote request button should have been disabled');
      return;
    }
    const denomination = product?.data?.denomination!;
    const productId = fromSecondaryMarket.referential.legacyProduct.getSecondaryMarketAstroProductId(state, isin)!;
    const productIdSource = fromSecondaryMarket.referential.legacyProduct.getSecondaryMarketAstroProductIdSource(
      state,
      isin,
    )!;
    const productIdType = fromSecondaryMarket.referential.legacyProduct.getSecondaryMarketAstroProductIdType(
      state,
      isin,
    )!;
    const client = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormClient(state, tabId);
    if (client === undefined || client.id === undefined || client.label === undefined) {
      getFrontLogger().error('can not quote as client is not found');
      return;
    }
    const dealSplitRows = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormDealSplitRows(state, tabId);
    const quantity = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormQuantity(state, tabId)!;
    const notional = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormNotional(state, tabId)!;
    const tradeWay = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormTradeWay(state, tabId)!;
    const hasUpfrontFee = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormHasUpfrontFee(state, tabId)!;
    const custodians = dealSplitRows.map(toCustodian);

    const request: IQuoteRequest = {
      correlationId,
      productIdSource,
      productIdType,
      productId,
      isin,
      denomination,
      client: { id: client.id, name: client.label, custodians },
      custodians,
      quantity: quantity,
      tradeNotional: notional,
      tradeSide: tradeWay,
      hasUpfront: hasUpfrontFee,
      timeZone,
    };
    dispatch(secondaryMarketQuoteRequested(tabId, request));
  };
}

export const secondaryMarketQuoteCancelledThunk = (tabId: string): Thunk<void> => {
  return (dispatch, getState) => {
    const state = getState();
    const quoteId = getSecondaryMarketRtFormQuoteId(state, tabId);
    dispatch(secondaryMarketQuoteCancelled(tabId, quoteId!));
  };
};
